<svelte:options tag='swc-input' immutable={true} />

<script>
  import { onMount } from 'svelte';
  import { get_current_component } from 'svelte/internal';
  import { initEventDispatcher } from '../helpers/init-event-dispatcher';
  import { generateRandomString } from '../helpers/generate-random-string';
  import ValidationMessage from './ValidationMessage.svelte';

  export let placeholder = '';
  export let value = '';
  export let validationmessage = null;
  export let focusoninit = 'false';
  export let autocomplete = '';
  export let isformpristine = true;
  export let settabindex = null;
  export let hidevalidationonmobile = false;
  export let spellcheck = false;
  export let hideborder = false;

  let input;
  let isPristine = true;

  const id = `input-${generateRandomString()}`;

  const focusIfFocusOnInit = () => {
    if (focusoninit === 'true') input.focus();
  };
  onMount(focusIfFocusOnInit);

  const dispatch = initEventDispatcher(get_current_component());
  const onUpdate = (newValue) => dispatch('update', newValue);
  const onBlur = () => {
    isPristine = false;
  };
  $: {
    onUpdate(value);
    if (!isformpristine) {
      isPristine = false;
    }
  };

</script>

<style>
  form, div {
    position: relative;
  }
  input {
    border: none;
    box-sizing: border-box;
    background-color: #F1F2F8;
    color: inherit;
    width: 100%;
    outline: none;
    line-height: 1;
    padding: 26px 14px 9px;
    border-radius: 0;
    text-overflow: ellipsis;
    font-size: 1rem;
    border-radius: 4px;
  }
  input.invalid {
    border-bottom-color: #ee3541;
  }
  input.hide-border {
    border: none;
  }
  label, input {
    font-family: inherit;
    letter-spacing: 0.5px;
    font-size: 1rem;
  }
  label {
    padding: 0 0 0 14px;
    opacity: 0.5;
    position: absolute;
    top: 50%;
    left: 0;
    transition: transform 0.2s;
    transform-origin: left;
    transform: translateY(-50%);
    pointer-events: none;
    user-select: none;
    font-size: 1rem;
  }
  input:focus + label, label.float-label {
    transform: translate(3px, -21px) scale(0.75);
  }
  input.invalid + label {
    color: #ee3541;
    opacity: 1;
  }
</style>

<form on:submit|preventDefault={() => false}>

  <div>
    <input
      id={id}
      class:invalid={!isPristine && validationmessage}
      class:hide-border={hideborder}
      bind:this={input}
      bind:value={value}
      autocomplete={autocomplete}
      on:blur={onBlur}
      tabindex={settabindex}
      spellcheck={spellcheck} />
    <label class:float-label={value} for={id}>
      {placeholder}
    </label>
  </div>

</form>
